import { useMemo } from 'react'

import useSepa from '@pages/Checkout/hooks/Payment/Transdev/useSepa'
import { MethodMap } from '@pages/Checkout/hooks/Payment/useBookingPayment'

export const useTransdevMethods = (): MethodMap => {
  const sepa = useSepa()

  return useMemo(() => {
    const result: MethodMap = {}
    if (sepa) {
      result.sepaDirectDebit = sepa
    }

    return result
  }, [sepa])
}
